module.exports = __webpack_public_path__ + "static/media/IconReportAnswers.4238ba7b.svg";